/* eslint-disable @nx/enforce-module-boundaries */
import { useMemo, useState } from 'react';
import { useCompanies } from 'v4/lib/hooks/use-companies';
import { CustomDropdown } from '../custom-dropdown';

export const CompaniesDropdown = ({ onChange, ...props }) => {
  const [search, setSearch] = useState(props?.value ?? props?.defaultValue);
  const { data, createLoading, mutateAsync, isLoading } = useCompanies({ search });

  const companies = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  const handleCreateCompany = async (name) => {
    try {
      // const resp = await mutateAsync({ name });
      // if (resp) {
        onChange?.({ name });
      // }
    } catch (e) {
      console.error('Error creating company:', e);
    }
  };

  return (
    <CustomDropdown
      {...props}
      allowCreate={true}
      data={companies}
      isLoading={isLoading}
      createLoading={createLoading}
      onSearch={setSearch}
      onChange={onChange}
      onCreateItem={handleCreateCompany}
    />
  );
};
